import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchHealthCheckupBanner, fetchHealthCheckupDetails, fetchHealthCheckupComparison,
  downloadHealthBrochure, fetchHealthCheckupDetailsBySlug, fetchHealthCheckupPageSeo
} from "../Adapter/PageAdapter";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Toaster, toast } from 'sonner';
import bannerImage from "../assets/images/spciallites/speciban.jpg";
import arrSvg from "../assets/images/arrw.svg";
import greenSVG from "../assets/images/greenarw.svg";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";

const HealthCheckup = () => {
  const [bannerData, setBannerData] = useState(null);
  const [healthPackages, setHealthPackages] = useState([]);
  const [compareList, setCompareList] = useState([]);
  const [showComparePopup, setShowComparePopup] = useState(false);
  const navigate = useNavigate();
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const loadSeo = async () => {
      try {
        console.log("Calling fetchHealthCheckupPageSeo...");
        const res = await fetchHealthCheckupPageSeo();
        console.log("API Response:", res);
        if (res && res.data) {
          setSeoData(res.data);
        }
      } catch (e) {
        console.error("Direct SEO fetch failed:", e);
      }
    };

    loadSeo();
  }, []);

  // const seoData = useSeo(fetchHealthCheckupPageSeo);

  useEffect(() => {
    const fetchHealthCheckups = async () => {
      try {

        const bannerResponse = await fetchHealthCheckupBanner();
        setBannerData(bannerResponse.data);

        const response = await fetchHealthCheckupDetails();
        if (response && response.data) {
          setHealthPackages(response.data);
        }
      } catch (error) {
        console.error("Error fetching health checkup details:", error);
      }
    };

    fetchHealthCheckups();
  }, []);

  const handleApplyNow = (id, slug) => {
    const formatterslug = slug.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
    localStorage.setItem("checkupId", id);
    navigate(`/health-checkup/${formatterslug}`);
  };

  const handleAddToCompare = (pkg) => {
    // Add or remove the package to/from the compareList
    setCompareList((prevList) => {
      if (prevList.some((item) => item.checkup_id === pkg.checkup_id)) {
        return prevList.filter((item) => item.checkup_id !== pkg.checkup_id); // Remove if already added
      }
      if (prevList.length >= 3) {
        alert("You can only compare up to 3 packages.");
        return prevList; // Prevent adding more than 3 items
      }
      return [...prevList, pkg]; // Add the new package
    });
    setShowComparePopup(true);
  };

  const handleRemoveFromCompare = (id) => {
    const updatedList = compareList.filter((item) => item.checkup_id !== id);
    setCompareList(updatedList);
    if (updatedList.length === 0) {
      setShowComparePopup(false);
    }
  };

  const handleCompare = async () => {
    if (compareList.length < 2) {
      alert("You need to select at least two packages to compare.");
      return;
    }

    const ids = compareList.map((pkg) => pkg.checkup_id);
    console.log("IDs for comparison:", ids); // Debugging log for selected IDs

    try {
      const response = await fetchHealthCheckupComparison(ids);
      console.log("API Response:", response); // Debugging log for API response
      if (response && response.data) {
        navigate("/health-checkup-comparison", { state: { ids, comparisonData: response.data } });
      } else {
        console.error("Invalid response from the comparison API");
        alert("Failed to fetch comparison data.");
      }
    } catch (error) {
      console.error("Error fetching comparison data:", error);
      alert("An error occurred while fetching the comparison data.");
    }
  };

  const handleDownloadPDF = async () => {
    try {
      await downloadHealthBrochure();
      toast.success("PDF downloaded successfully!", { position: "top-right" });
    } catch (error) {
      toast.error("Failed to download the PDF.", { position: "top-right" });
    }
  };

  return (
    <div>
      {/* {seoData && <SeoHelmet seoData={seoData} />} */}
      {seoData && (
        <Helmet>
          <title>{seoData.seo_title}</title>
          <meta name="title" content={seoData.meta_title} />
          <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
          <meta name="keywords" content={seoData.meta_keywords} />

          <meta property="og:title" content={seoData.og_title} />
          <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
          <meta property="og:type" content={seoData.og_type} />
          <meta property="og:url" content={seoData.og_url} />
          <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
          <meta property="og:locale" content={seoData.og_locale} />
          <meta property="og:site_name" content={seoData.og_site_name} />
          <meta property="article:modified_time" content={seoData.article_modified_time} />

          <meta name="twitter:card" content={seoData.twitter_card} />
          <meta name="twitter:title" content={seoData.twitter_title} />
          <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
          <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
          <meta name="twitter:site" content={seoData.twitter_site} />

          <link rel="canonical" href={seoData.canonical_link} />

          {/* Custom scripts injection */}
          {seoData.custom_scripts && (
            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
          )}
        </Helmet>
      )}
      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            {bannerData && bannerData.img_path ? (
              <img src={`${baseImage_path}${bannerData.img_path.replace(/^\./, "")}`}
                alt="Health Checkups" />
            ) : (
              <img
                src={bannerImage}
                alt="Default Banner"
              />
            )}
            <div className="ban-con">
              <h1>Health Check Ups</h1>
            </div>
          </div>
        </div>
      </section>
      <Toaster position="top-right" />

      {/* Introduction Section */}
      <section className="section about-host">
        <div className="cust-container">
          <div className="row">
            <div className="col-md-12">
              <div className="finnest host-det mobtopmarg">
                <h4>Prevention Begins with You: Stay Ahead of Disease with <span> Regular Check-Ups.</span></h4>

                <p>At S.L. Raheja Hospital, we offer a comprehensive range of services tailored to meet the diverse healthcare needs of individuals and families. Regular health check-ups are essential in today’s fast-paced world, empowering you to take charge of your health, identify potential risks early, and avoid costly treatments down the line. Early detection can be life-saving—giving you the chance to address health concerns before they become serious. Take the first step towards a healthier future with us.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Health Checkup Packages Section */}
      <section className="fivepointsec mrgntop70 margnbot90 healthcheckup-sec">
        <div className="cust-container">
          <div className="fivepoint-desc">
            <p>S.L. Raheja Hospital offers a variety of health packages designed to suit different <b>age groups,
              genders, and specific health needs.</b></p>
          </div>
          <div className="row">
            {healthPackages.map((pkg) => (
              <div key={pkg.checkup_id} className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
                <div className="healthcheckup-card">
                  <div className="healthcheckup-card-img">
                    <img
                      src={`${baseImage_path}${pkg.checkup_image || "images/hcuimage1.png"}`}
                      alt={pkg.checkup_title}
                    />
                  </div>
                  <div className="healthcheckup-desc">
                    <p>{pkg.checkup_title}</p>
                    <span>Rs. {pkg.checkup_fees}/-</span>
                    <div className="healthcheckup-ctas">
                      <button
                        className="btn with-color with-arr"
                        onClick={() => handleApplyNow(pkg.checkup_id, pkg.slug)}
                      >
                        <img src={arrSvg} alt="Apply Now" /> Know More
                      </button>
                      <div className="healthcheckup-compare">
                        <label>
                          <input
                            type="checkbox"
                            checked={compareList.some((item) => item.checkup_id === pkg.checkup_id)}
                            onChange={() => handleAddToCompare(pkg)}
                          />
                          <span style={{ marginLeft: "5px", color: "#000000", cursor: "pointer" }}>Compare</span>
                        </label>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            ))}
            {/* <div className="jdapplybtn healthcheckchkupcta">
              <a href="#" className="btn with-color with-arr" onClick={downloadHealthBrochure}><img src={arrSvg} alt="" />Download Brochure</a>
            </div> */}
            <div className="jdapplybtn healthcheckchkupcta">
              <button className="btn with-color with-arr" onClick={handleDownloadPDF}>
                <img src={arrSvg} alt="" /> Download Brochure
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Compare Popup */}
      {compareList.length > 0 && (
        <div className="compare-popup">
          <div className="compare-header">
            <button className="clear-btn" onClick={() => setCompareList([])}>
              X
            </button>
          </div>
          <div className="compare-items">
            <div className="compare-flex">
              {compareList.map((pkg) => (

                <div key={pkg.checkup_id} className="compare-item">
                  <img
                    src={`${baseImage_path}${pkg.checkup_image || "/images/health_checkups/Comprehensive-men.png"}`}
                    alt={pkg.checkup_title}
                    className="compare-img"
                  />
                  <div className="compare-details">
                    <p>{pkg.checkup_title}</p>
                    <span>Rs. {pkg.checkup_fees}/-</span>
                  </div>

                  <button className="compare-remove" onClick={() => handleRemoveFromCompare(pkg.checkup_id)}>
                    X
                  </button>
                </div>
              ))}
            </div>
            <div className="Compare-btn">
              <button className="compare-now-btn" onClick={handleCompare}>
                <img src={greenSVG} alt="Compare" />  Compare
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HealthCheckup;
